import fetchMock from 'fetch-mock';
import { Config } from '../config';

const config = new Config();

const mockService = {
    install: () => {
        fetchMock.get(
            config.API_BASE_URL + '/products/countries',
            {
                countries: [
                    {
                        id: 103,
                        name: "Kenya",
                        prefix: "254",
                        iso2: "KE",
                        iso3: "KEN"
                    },
                    {
                        id: 75,
                        name: "Ghana",
                        prefix: "233",
                        iso2: "GH",
                        iso3: "GHA"
                    }
                ]
            }
        );
        fetchMock.get(
            config.API_BASE_URL + '/countries',
            {
                countries: [
                    {
                        id: 103,
                        name: "Kenya",
                        prefix: "254",
                        iso2: "KE",
                        iso3: "KEN"
                    },
                    {
                        id: 75,
                        name: "Ghana",
                        prefix: "233",
                        iso2: "GH",
                        iso3: "GHA"
                    }
                ]
            }
        );
        fetchMock.get(
            config.API_BASE_URL + '/countries/103/currencies',
            {
                currencies: [
                    {
                        id: 73,
                        iso: "KES",
                        symbol: null,
                        rate: 0.008279
                    }
                ]
            }
        );
        fetchMock.get(
            config.API_BASE_URL + '/countries/75/currencies',
            {
                currencies: [
                    {
                        id: 51,
                        iso: "GHS",
                        symbol: null,
                        rate: 0.155323
                    }
                ]
            }
        );
        fetchMock.get(
            config.API_BASE_URL + '/countries/103/currencies/73/transaction-types',
            {
                transaction_types: [
                    {
                        id: 1,
                        code: 'MOBILE_MONEY'
                    },
                    {
                        id: 2,
                        code: 'BANK_ACCOUNT'
                    }
                ]

            }
        );
        fetchMock.get(
            config.API_BASE_URL + '/countries/75/currencies/51/transaction-types',
            {
                transaction_types: [
                    {
                        id: 1,
                        code: 'MOBILE_MONEY'
                    },
                    {
                        id: 3,
                        code: 'BANK_ACCOUNT_WITH_LOCATIONS'
                    }
                ]
            }
        );


        fetchMock.get(
            config.API_BASE_URL + '/agents/153/account-types',
            {
                account_types: [
                    {
                        id: 1,
                        name: 'Phone number',
                        validation_method: 'PHONE'
                    },
                ]
            }
        );
        fetchMock.get(
            config.API_BASE_URL + '/agents/154/account-types',
            {
                account_types: [
                    {
                        id: 1,
                        name: 'Bank account',
                        validation_method: 'REGEX',
                        regex: '^\w{1,17}$'
                    },
                ]
            }
        );

        fetchMock.get(
            config.API_BASE_URL + '/agents/154/locations',
            {
                locations: [
                    {
                        id: 1,
                        country_id: 1,
                        name: 'Location 1',
                    },
                    {
                        id: 2,
                        country_id: 1,
                        name: 'Location 2',
                    }
                ]
            }
        );


        fetchMock.get(
            'begin:' + config.API_BASE_URL + '/agents',
            (url, opts) => {
                const params = new URLSearchParams(url);
                if (params.get('transaction_type_code') === 'MOBILE_MONEY') {
                    return {
                        agents: [
                            {
                                id: 153,
                                name: 'MPESA'
                            }
                        ]
                    }
                } else {
                    return {
                        agents: [
                            {
                                id: 154,
                                name: 'BANK 1'
                            }
                        ]
                    }

                }
            }
        );
        fetchMock.get(
            'begin:' + config.API_BASE_URL + '/products/parameters/verify',
            (url, opts) => {
                const params = new URLSearchParams(url);
                if (Number(params.get('amount')) < 10) {
                    return {
                        status: 409,
                        body: {
                            amount_requirements: [
                                {
                                    min: 10,
                                    max: null,
                                    multiple_of: null
                                }
                            ]
                        }
                    }
                }
                return 200;
            }
        );
        fetchMock.get(
            'begin:' + config.API_BASE_URL + '/products',
            {
                product_id: 1,
                total_cost: 1.25,
                total_pay: 999
            }
        );
        fetchMock.post(
            config.API_BASE_URL + '/checkout',
            {
                revolupay_order_id: 1,
                revolupay_order_reference: 'D08C2AD5-B7AE-4548-A821-B6A8C5BC097B'
            }
        );
        fetchMock.get(
            config.API_BASE_URL + '/revolupay_orders/1/payment',
            new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(200);
                }, 5000);
            })
        );
    }
}

export default mockService;